import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import apiFetch from "../../Api";

const ExamResultPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [examResult, setExamResult] = useState(null);
    const [message, setMessage] = useState({ type: '', text: '' });

    useEffect(() => {
        const fetchExamResult = async (examName) => {
            try {
                const response = await apiFetch(`/api/exam/result?examName=${encodeURIComponent(examName)}`);
                const data = await response.json();

                if (response.ok) {
                    setExamResult(data);
                } else {
                    setMessage({ type: 'error-message', text: data.errorMessage || 'Nie udało się pobrać wyników egzaminu.' });
                }
            } catch (error) {
                console.error('Błąd podczas pobierania wyników egzaminu:', error);
                setMessage({ type: 'error-message', text: 'Wystąpił błąd sieci lub serwera.' });
            }
        };

        if (location.state && location.state.examResult) {
            // Wyniki przekazane ze strony egzaminu
            setExamResult(location.state.examResult);
        } else {
            // Spróbuj pobrać wyniki na podstawie nazwy egzaminu z URL (po odświeżeniu strony)
            const examName = searchParams.get('examName');
            if (examName) {
                fetchExamResult(examName);
            } else {
                setMessage({ type: 'error-message', text: 'Brak danych o wynikach egzaminu.' });
            }
        }
    }, [location.state, searchParams]);

    // Funkcja pomocnicza do formatowania daty
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleString('pl-PL', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    };

    if (!examResult) {
        return (
            <div>
                <div className="container">
                    {message.text && (
                        <div className={`message ${message.type}`}>
                            {message.text}
                        </div>
                    )}
                    <p>Ładowanie wyników egzaminu...</p>
                    <button onClick={() => navigate('/home')} className="button-link">Wróć na stronę główną</button>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className="container">
                <div className="messages-container">
                    <h2 style={{ textAlign: 'center' }}>{examResult.examName}</h2>
                    <p><strong>Całkowita liczba pytań:</strong> {examResult.totalQuestions}</p>
                    <p><strong>Poprawne odpowiedzi:</strong> {examResult.correctAnswers}</p>
                    <p><strong>Procentowy wynik:</strong> {examResult.scorePercentage}%</p>
                    <p><strong>Data zakończenia:</strong> {formatDate(examResult.submissionTime)}</p>

                    <h3>Szczegóły pytań:</h3>
                    {examResult.questionResults.map((qr, qrIndex) => (
                        <div key={qrIndex} className="question-summary">
                            <p>
                                <strong>{qrIndex + 1}.</strong> {qr.questionText}
                                {qr.sourceReference && <span className="source-reference"> ({qr.sourceReference})</span>}
                            </p>
                            <ul>
                                {qr.allAnswers.map((answer, aIndex) => {
                                    let className = 'normal-answer';
                                    if (aIndex === qr.correctAnswerIndex) {
                                        className = 'correct-answer';
                                    } else if (aIndex === qr.chosenAnswerIndex) {
                                        className = 'wrong-user-answer';
                                    }
                                    return (
                                        <li key={aIndex} className={className}>
                                            <span>{answer.text}</span>
                                            {aIndex === qr.correctAnswerIndex && <span> (Poprawna)</span>}
                                            {aIndex === qr.chosenAnswerIndex && !qr.correct && <span> (Twoja odpowiedź)</span>}
                                            {aIndex === qr.chosenAnswerIndex && qr.correct && <span> (Twoja poprawna odpowiedź)</span>}
                                        </li>
                                    );
                                })}
                            </ul>
                            {!qr.correct && <p style={{ color: 'red' }}>Twoja odpowiedź była błędna.</p>}
                            {qr.correct && <p style={{ color: 'green' }}>Twoja odpowiedź była poprawna.</p>}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ExamResultPage;